// Per-app `environment.services` map: a feature flag per hydrate effect deciding whether
// it runs. Effects are DI classes but read this inside `iif(() => ...)` lambdas, so a
// module-level setter (like scope-config.ts) is simpler than threading a token through
// ~11 effect constructors. Each app calls setServicesConfig(environment.services) once at
// AppModule load.
// Intentionally loose — each app's `environment.services` is a concrete interface
// (EnvironmentServices) with no index signature; this util only ever does a keyed lookup.
let config: Record<string, any> = {};

export function setServicesConfig(next: Record<string, any>): void {
	config = next || {};
}

export function isServiceEnabled(name: string): boolean {
	return !!config[name];
}
